<template>
  <div>
    <div class="panel-heading">
      <h4 class="panel-title">{{ $t('invoice.creditInvoiceTitle') }}</h4>
    </div>

    <div
      class="panel-body"
      style="display: block;"
    >
      <div class="row">
        <preDatatableComponent
          :removeAddButton="true"
          :removeWarehouseDeliverButton="true"
          :tableData="tableData"
          :resetGetResults="resetGetResults"
          :resetGetResults2="resetGetResults2"
          :searchMe="searchMe"
          :enableCustomerSearchSuggestions="true"
          :pagination="pagination"
          :perPageFix="perPageFix"
          :filterTable="filterTable"
          :addExportButton="true"
          :sendToExport="sendToExport"
          :columns="columns"
          :showHideColumn="showHideColumn"
          :storageKey="'cols_creditLogAction_v1'"
          :resultsVersion="resultsVersion"
          :filterMade="filterMade"
          :totalResult="totalResult"
          :paymentFilterItems="paymentMethodFilterItems"
          :paymentFilterChange="handlePaymentMethodFilter"
          :noWrapFilters="true"
          @branch-edit="branchEdit"
        ></preDatatableComponent>
        <div class="col-xs-12">
          <div class="row text-center">
            <span
              id="test-editable"
              style="opacity:0"
            ></span>
          </div>
          <datatable
            v-if="!isMobile"
            :sortDir="tableData.sortDir"
            :columns="columns"
            :sortByColumn="sortByColumn"
            :searchOneCol="searchOneCol"
            :sortKey="sortKey"
            :sortOrders="sortOrders"
          >
            <tbody>
              <tr
                v-for="r in apiResults"
                :key="r.credit_log_action_id"
              >
                <!-- <td v-if="r.is_open === '0'">
                  <div class="media-left">
                    {{ r.branch_name }}
                    <span
                      class="status-mark bg-danger-600 media-badge"
                      style="margin-top: 2px; left: -10px"
                    ></span>
                  </div>
                </td>
                <td v-else>{{ r.branch_name }}</td> -->
                <td v-if="r.is_open === '0'">
                  <div class="media-left">
                    {{ r.staff_name }}
                    <span
                      class="status-mark bg-danger-600 media-badge"
                      style="margin-top: 2px; left: -10px"
                    ></span>
                  </div>
                </td>
                <td v-else>{{ r.staff_name }}</td>

                <td>{{ r.customer_id }}</td>
                <td class="ws-nowrap">
                  {{ r.customer_name }}
                  <open-whatsapp-and-viber :phoneNumber="r.customer_phone_number" />
                </td>
                <td class="customer-note-color"> {{ r.customer_note }} </td>
                <td v-if="r.action === 'add'">
                  <span class="label bg-green-400"> {{ r.action }}</span>
                </td>
                <td v-else-if="r.action === 'update'">
                  <span class="label bg-blue-400"> {{ r.action }}</span>
                </td>
                <td v-else-if="r.action === 'delete'">
                  <span class="label bg-danger-400"> {{ r.action }}</span>
                </td>
                <td v-else>
                  <span class="label bg-orange-600"> {{ r.action }}</span>
                </td>

                <td>${{ r.amount }}</td>
                <td>{{ displayExRate(r) }}</td>
                <td>
                  <span
                    v-if="paymentMethodLabel(r.payment_method)"
                    style="display:inline-block; padding:2px 8px; border-radius:12px; font-size:12px; font-weight:500;"
                    :style="{ backgroundColor: paymentMethodColor(r.payment_method).bg, color: paymentMethodColor(r.payment_method).color }"
                  >{{ paymentMethodLabel(r.payment_method) }}</span>
                  <span v-else>—</span>
                </td>
                <td v-if="r.credit_log_action_date != null">{{ r.credit_log_action_date }}</td>
                <td v-else>{{ r.created_at }}</td>
                <td style="padding-left:10px; padding-right:10px">
                  <a
                    style="color:#424242"
                    :tooltip="$t('invoice.invoiceTooltip')"
                    @click="initDetail('modal_showApp', r.credit_log_action_id)"
                  >
                    <i class="material-icons">assignment</i>
                  </a>
                </td>
              </tr>
              <tr id="no-result-row">
                <td
                  :colspan="columns.length"
                  class="text-center"
                >
                  <v-alert
                    type="error"
                    :value="alertValue"
                  >
                    {{ $t('common.noResultsFound') }}
                  </v-alert>
                </td>
              </tr>
            </tbody>
            <tfoot v-if="footer">
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td
                  style="font-weight: bold; color: #616161; white-space: nowrap;"
                >{{ $t('printLogs.totalAmountLabel') }}: ${{ footer.total_amount }}</td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </tfoot>
          </datatable>

          <mobile-datatable
            v-if="isMobile"
            :isTransactionCredit="true"
          >
            <tbody>
              <tr
                v-for="r in apiResults"
                :key="r.order_id"
              >
                <td>
                  {{ $t('columns.staff') }}: {{ r.staff_name }} , <br />
                  {{ $t('columns.customerId') }}: {{ r.customer_id }} , <br />
                  {{ $t('columns.customerName') }}: {{ r.customer_name }}
                </td>

                <td>
                  <span v-if="r.action === 'add'">
                    <span class="label bg-green-400"> {{ r.action }}</span>
                  </span>
                  <span v-else-if="r.action === 'update'">
                    <span class="label bg-blue-400"> {{ r.action }}</span>
                  </span>
                  <span v-else-if="r.action === 'delete'">
                    <span class="label bg-danger-400"> {{ r.action }}</span>
                  </span>
                  <span v-else>
                    <span class="label bg-orange-600"> {{ r.action }}</span>
                  </span>

                  <br />${{ r.amount }} , <br />
                  {{ $t('logs.exRateLabel') }}: {{ displayExRate(r) }} , <br />
                  <span v-if="paymentMethodLabel(r.payment_method)">
                    <span
                      style="display:inline-block; padding:2px 8px; border-radius:12px; font-size:12px; font-weight:500;"
                      :style="{ backgroundColor: paymentMethodColor(r.payment_method).bg, color: paymentMethodColor(r.payment_method).color }"
                    >{{ paymentMethodLabel(r.payment_method) }}</span>
                    <br />
                  </span>
                  <span v-if="r.credit_log_action_date != null">{{
                    r.credit_log_action_date
                  }}</span>
                  <span v-else>{{ r.created_at }}</span>
                  , <br />
                  <a
                    style="color:#424242"
                    :tooltip="$t('invoice.invoiceTooltip')"
                    @click="initDetail('modal_showApp', r.credit_log_action_id)"
                  >
                    <i class="material-icons">assignment</i>
                  </a>
                </td>
              </tr>
              <tr id="no-result-row">
                <td
                  colspan="2"
                  class="text-center"
                >
                  <v-alert
                    type="error"
                    :value="alertValue"
                  >
                    {{ $t('common.noResultsFound') }}
                  </v-alert>
                </td>
              </tr>
            </tbody>
          </mobile-datatable>

          <!-- Credit receipt modal (viewActionLog): no per-line int. shipping column; order detail print uses viewLogDetails with price incl. int. ship. -->
          <view-action-log
            :detailData="detailData"
            :closeModal="closeModal"
            :companyData="companyData"
            :exRate="exRate"
          ></view-action-log>

          <hr />
          <div class="row">
            <div class="col-xs-12 text-right">
              <paginate
                :page-count="pagination.lastPage"
                :page-range="2"
                :changePage="changePage"
                :container-class="'pagination'"
                :pagination="pagination"
                :page-class="'page-item'"
              ></paginate>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PaginationVue from '../Pagination.vue'
import preDatatableComponent from '../preDatatableComponent.vue'
import DatatableVue from '../Datatable.vue'
import viewActionLog from './viewActionLog.vue'
import mobileDatatable from '../mobileDatatable'
import axios from 'axios'
import swal from 'sweetalert'

export default {
  components: {
    preDatatableComponent: preDatatableComponent,
    datatable: DatatableVue,
    paginate: PaginationVue,
    'view-action-log': viewActionLog,
    'mobile-datatable': mobileDatatable
  },
  created() {
    this.getResults()
  },
  mounted() {
    this.perPageFix()
    this.getCurrentExRate()

    if (screen.width <= 600) {
      this.isMobile = true
    } else {
      this.isMobile = false
    }
  },
  $_veeValidate: {
    validator: 'new'
  },
  data() {
    let sortOrders = {}
    let columns = [
      // {
      //   label: 'Branch',
      //   text: 'Branch',
      //   value: '1',
      //   sortable: true,
      //   searchable: false,
      //   name: 'branch_name'
      // },
      {
        label: this.$t('columns.staffName'),
        text: this.$t('columns.staffName'),
        value: '1',
        sortable: true,
        searchable: true,
        name: 'staff_name'
      },
      {
        label: this.$t('columns.customerId'),
        text: this.$t('columns.customerId'),
        value: '2',
        sortable: true,
        searchable: true,
        name: 'customer_id'
      },
      {
        label: this.$t('columns.customerName'),
        text: this.$t('columns.customerName'),
        value: '3',
        sortable: true,
        searchable: true,
        name: 'customer_name'
      },
      {
        label: this.$t('columns.customerNote'),
        text: this.$t('columns.customerNote'),
        value: '4',
        sortable: true,
        searchable: true,
        name: 'customer_note'
      },
      // {label: "Customer Email", text: 'OrderID', value: '2', sortable: true, searchable: true, name: "customer_email"},
      {
        label: this.$t('columns.action'),
        text: this.$t('columns.action'),
        value: '5',
        sortable: true,
        searchable: true,
        name: 'action'
      },
      {
        label: this.$t('columns.amount'),
        text: this.$t('columns.amount'),
        value: '6',
        sortable: true,
        searchable: true,
        name: 'amount'
      },
      {
        label: this.$t('columns.exRate'),
        text: this.$t('columns.exRate'),
        value: '7',
        sortable: true,
        searchable: false,
        name: 'ex_rate'
      },
      {
        label: this.$t('columns.paymentMethod'),
        text: this.$t('columns.paymentMethod'),
        value: '8',
        sortable: false,
        searchable: false,
        name: 'payment_method'
      },
      {
        label: this.$t('columns.logDate'),
        text: this.$t('columns.logDate'),
        value: '9',
        sortable: true,
        searchable: true,
        name: 'credit_log_action_date'
      }
    ]
    columns.forEach(column => {
      sortOrders[column.name] = -1
    })

    return {
      isMobile: false,
      loader: null,
      loading: false,
      url: 'api/credit_log_actions',
      logDetailUrl: 'api/credit_log_actions',
      companyUrl: 'api/company_info',
      exRate: 1,
      rowIndex: '',
      alertValue: false,
      checkAlert: false,
      btnsave: true,
      filterMade: false,
      totalResult: 0,
      footer: null,
      paymentMethodFilterItems: [
        { text: this.$t('invoice.officeOption'), value: 'office' },
        { text: 'QI', value: 'qi' },
        { text: 'FIB', value: 'fib' },
        { text: 'FastPay', value: 'fastpay' }
      ],
      detailData: {
        credit_log_action_id: '',
        invoice_number: '',
        description: '',
        action: '',
        created_at: '',
        amount: '',
        ex_rate: null,
        customer_name: '',
        customer_email: '',
        customer_address: '',
        phone_number: '',
        note: '',
        credit_log_action_date: '',
        base_invoice_number: ''
      },
      companyData: {
        company_name: '',
        company_address: '',
        company_email: ''
      },
      prevSearchQuery: '',
      apiResults: [],
      resultsVersion: 0,
      creditLogActionID: [],
      columns: columns,
      sortKey: 'credit_log_action_id',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'credit_log_action_id',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: '',
        branches_id: '',
        payment_filter: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    }
  },

  methods: {
    branchEdit(branches) {
      this.tableData.branches_id = branches.toString()
      this.getResults()
    },

    // Idempotent "set" style (rather than the toggle-diffing this used to do) — safe to call
    // repeatedly with the same currentColVal, which is required for the storageKey/
    // resultsVersion re-application in preDatatableComponent.vue to work: hidden columns need
    // to stay hidden across every data reload, not just the first time this runs.
    showHideColumn(prevColVal, currentColVal) {
      const hidden = {}
      currentColVal.forEach((v) => { hidden[v] = true })

      for (let i = 1; i <= this.columns.length; i++) {
        const selector = '#datatable td:nth-child(' + i + '),#datatable th:nth-child(' + i + ')'
        if (hidden[i]) {
          $(selector).hide()
        } else {
          $(selector).show()
        }
      }
    },

    sendToExport() {
      let arr = ''

      for (let i = 0; i < this.creditLogActionID.length; i++) {
        if (i < this.creditLogActionID.length - 1) {
          arr = arr.concat('arr[]=' + this.creditLogActionID[i] + '&')
        } else {
          arr = arr.concat('arr[]=' + this.creditLogActionID[i])
        }
      }

      let hostName = window.location.hostname
      let protocol = window.location.protocol + '//'
      let fullHostName = protocol + hostName
      window.location.replace(fullHostName + '/api/transaction-credit-export?' + arr)
    },

    getResults(url = this.url) {
      var token = localStorage.getItem('access_token')
      let theDatatable = document.querySelector('.the-datatable')
      let thePanel = document.querySelector('.panel-flat')

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out')
        thePanel.style.overflowX = 'auto'
      }

      axios
        .get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          let data = response.data
          if (data.data.footer) {
            this.footer = data.data.footer
          }
          // Both the paginated (default) and flat (search/date-filtered) responses now shape
          // their rows the same way (data.data.data) and both carry .footer - only a real
          // paginator response has current_page, so that's what distinguishes them here (this
          // used to check Array.isArray(data.data), back when the flat response was a bare
          // array instead of {data, footer}).
          const isFlatArray = data.data.current_page === undefined
          this.filterMade = isFlatArray
          this.apiResults = data.data.data
          this.resultsVersion++

          if (this.apiResults.length === 0) {
            this.tableData.searchOneCol = ''
            this.tableData.searchOneVal = ''
            this.tableData.search = ''
            this.alertValue = true
          } else {
            this.alertValue = false
          }
          if (isFlatArray) {
            this.removeConfigPagination()
          } else {
            this.configPagination(data.data)
          }
          this.getCreditLogActionID(this.apiResults)
          theDatatable.classList.remove('slide-table-out')
          setTimeout(function () {
            thePanel.style.overflowX = 'auto'
          }, 0)
        })
        .then(() => {
          this.totalResult = 0
          for (let i = 0; i < this.apiResults.length; i++) {
            this.totalResult += 1
          }
        })
        .catch(errors => { console.error(errors) })
    },

    getCreditLogActionID(creditLog) {
      this.creditLogActionID = []
      for (let i = 0; i < creditLog.length; i++) {
        this.creditLogActionID[i] = creditLog[i].credit_log_action_id
      }
    },

    removeConfigPagination() {
      this.pagination.lastPage = ''
      this.pagination.currentPage = ''
      this.pagination.total = ''
      this.pagination.lastPageUrl = ''
      this.pagination.nextPageUrl = ''
      this.pagination.prevPageUrl = ''
      this.pagination.from = ''
      this.pagination.to = ''
    },

    resetGetResults() {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'credit_log_action_id'
      this.tableData.sortDir = 'dsc'
      this.tableData.column = 'credit_log_action_id'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.tableData.payment_filter = ''
      this.filterTable(this.tableData.from_date, this.tableData.to_date)
      this.sortByColumn()
      this.getResults()
    },

    resetGetResults2() {
      this.queryParameter = false
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'credit_log_action_id'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'credit_log_action_id'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.tableData.payment_filter = ''
      this.getResults()
    },

    handlePaymentMethodFilter(val) {
      this.tableData.payment_filter = val && val.length > 0 ? val.join(',') : ''
      this.getResults()
    },

    perPageFix(perPage) {
      this.tableData.per_page = perPage
      this.getResults()
    },

    modal(modal) {
      $('#' + modal).modal({ backdrop: 'static' })
    },

    closeModal(modal) {
      this.getResults()
      let theModal = $('#' + modal)
      theModal.modal('toggle')
    },

    // Used both up front (mounted(), so the list's Ex Rate column has a fallback ready for any
    // row without its own stored rate) and again on each initDetail() open, so the receipt
    // modal's fallback is as fresh as possible if the rate changed since the page loaded.
    getCurrentExRate() {
      let token = localStorage.getItem('access_token')
      axios
        .get('api/currency-rate/latest', { headers: { Authorization: 'Bearer ' + token } })
        .then(res => { this.exRate = res.data ? res.data.ex_rate || 1 : 1 })
        .catch(() => {})
    },

    initDetail(modal, id) {
      let token = localStorage.getItem('access_token')
      this.getCompanyData(token)
      this.getCurrentExRate()
      axios
        .get(this.logDetailUrl + '/' + id, { headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          this.detailData = response.data.data
          this.detailData.phone_number = response.data.data.customer_phone_number
        })
      this.modal(modal)
    },

    getCompanyData(token) {
      axios
        .get(this.companyUrl, { headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          let data = response.data
          let companyResult = []
          companyResult = data.data

          this.companyData.company_name = companyResult.company_name
          this.companyData.company_address = companyResult.company_address
          this.companyData.company_email = companyResult.company_email
        })
    },

    changePage(pageUrl) {
      this.url = pageUrl
      this.getResults()
    },

    searchMe(str) {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      if (str.trim() !== '') {
        this.tableData.search = str
        this.prevSearchQuery = str
        this.getResults()
      } else {
        swal({
          text: this.$t('common.typeToSearch'),
          icon: 'warning',
          dangerMode: true
        })
        if (this.prevSearchQuery !== '') {
          this.tableData.search = ''
          this.prevSearchQuery = ''
          this.getResults()
        }
      }
    },

    sortByColumn(str) {
      this.tableData.column = str
      this.tableData.sortKey = str
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc'
      this.getResults()
    },

    searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName
      this.tableData.searchOneVal = str
      this.getResults()
    },

    filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate
      this.tableData.to_date = toDate
      this.getResults()
    },

    configPagination(data) {
      this.pagination.lastPage = data.last_page
      this.pagination.currentPage = data.current_page
      this.pagination.total = data.total
      this.pagination.lastPageUrl = data.last_page_url
      this.pagination.nextPageUrl = data.next_page_url
      this.pagination.prevPageUrl = data.prev_page_url
      this.pagination.from = data.from
      this.pagination.to = data.to
    },

    // Mirrors CreditLogAction::OFFICE/QI/FIB/FASTPAY (app/CreditLogAction.php). Only genuinely
    // meaningful for rows from a payment_method-aware flow (the FIB/QI webhook top-up) — the
    // column defaults to 'office' at the DB level, and the manual "Add Credit" flow
    // (CreditInvoiceController::store(), bound to bank_id_fk — a bank account, not a payment
    // method choice) never overrides that default, so those rows always show "Office" here
    // regardless of which bank was actually used, not a verified payment method.
    paymentMethodLabel(paymentMethod) {
      const map = {
        office: this.$t('invoice.officeOption'),
        qi: 'QI',
        fib: 'FIB',
        fastpay: 'FastPay'
      }
      return map[paymentMethod] || null
    },

    paymentMethodColor(paymentMethod) {
      const map = {
        office: { bg: '#F5F5F5', color: '#424242' },
        qi: { bg: '#D1C4E9', color: '#4527A0' },
        fib: { bg: '#C8E6C9', color: '#1B5E20' },
        fastpay: { bg: '#FFE0B2', color: '#E65100' }
      }
      return map[paymentMethod] || { bg: '#F5F5F5', color: '#616161' }
    },

    // Every row created since the ex_rate migration/backfill (see add_ex_rate_to_credit_log_
    // actions_table + credit_log_actions:backfill-ex-rate) has its own historical rate. Falls
    // back to today's live rate (this.exRate, fetched in mounted()/initDetail()) only for a row
    // where that genuinely isn't available — same fallback principle as viewActionLog.vue's
    // Total IQD, applied here to the list instead of the single-record receipt.
    displayExRate(r) {
      return Number(r.ex_rate) > 0 ? r.ex_rate : this.exRate
    }
  }
}
</script>

<style>
@media screen and (max-width: 600px) {
  th {
    font-weight: bold;
    color: #273246;
    padding-left: 5px !important;
  }

  td {
    padding-left: 5px !important;
    padding-top: 10px !important;
    padding-bottom: 10px !important;
  }
}

.panel-heading h4 {
  text-transform: uppercase;
  margin-left: -20px;
  padding-left: 10px;
  font-weight: 500;
}

.col-xs-12 {
  padding-top: 10px;
  padding-bottom: 10px;
}
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: hidden;
  overflow-y: hidden;
}
.page-stats {
  align-items: center;
  position: relative;
  top: -8px;
  margin-right: 5px;
}

@media screen and (max-width: 767px) {
  .form-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}

a:hover {
  color: #03a9f4;
  position: relative;
}
a[tooltip]:hover:after {
  content: attr(tooltip);
  padding: 8px 12px;
  color: #ffffff;
  position: absolute;
  right: 80%;
  bottom: 150%;
  white-space: nowrap;
  z-index: 20;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  border-radius: 3px;
  -moz-box-shadow: 0px 0px 2px #484b4e;
  -webkit-box-shadow: 0px 0px 2px #484b4e;
  box-shadow: 0px 0px 2px #484b4e;
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(0, #484b4e),
    color-stop(1, #484b4e)
  );
  background-image: -webkit-linear-gradient(top, #484b4e, #484b4e);
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -ms-linear-gradient(top, #484b4e, #484b4e);
  background-image: -o-linear-gradient(top, #484b4e, #484b4e);
}
</style>



// WEBPACK FOOTER //
// src/components/logs/creditLogAction.vue